"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forEachDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var forEachDependencies = exports.forEachDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createForEach: _factoriesAny.createForEach
};